<template>
	<CCard>
		<CCardHeader>
			<h5>Reset Password</h5>
		</CCardHeader>
		<CCardBody>
			<CForm>
				<CInput
					label="Current Password"
					type="password"
					horizontal
					autocomplete="curent-password"
					:value.sync="$v.loginDetails.oldPassword.$model"
					:lazy="false"
					:isValid="checkIfValid('oldPassword')"
					invalidFeedback="Enter a valid password"
					class="login-form-group"
					@keyup.enter="loginHandler"
					@input="error = null"
				/>
				<CInput
					label="New Password"
					type="password"
					horizontal
					autocomplete="curent-password"
					:value.sync="$v.loginDetails.password.$model"
					:lazy="false"
					:isValid="checkIfValid('password')"
					invalidFeedback="Enter a valid password"
					class="login-form-group"
					@keyup.enter="loginHandler"
					@input="error = null"
				/>
				<CInput
					label="Confirm Password"
					horizontal
					type="password"
					autocomplete="curent-password"
					:value.sync="$v.loginDetails.confirmPassword.$model"
					:lazy="false"
					:isValid="checkIfValid('confirmPassword')"
					invalidFeedback="Confirm password must be same as password"
					class="login-form-group"
					@keyup.enter="loginHandler"
					@input="error = null"
				/>
			</CForm>
			<p
				:style="{
					color: 'red',
					textAlign: 'center',
				}"
			>
				{{ error }}
			</p>
		</CCardBody>
		<CCardFooter>
			<CButton color="primary" @click="handleReset">Reset</CButton>
		</CCardFooter>
		<CModal
			title="Reset Password"
			:show.sync="resetModal"
			class="disable-footer"
			centered
			fade
			:closeOnBackdrop="false"
		>
			<center>
				Are you sure you want to change password ?
				<div class="inactive-modal-response">
					<CButton
						type="submit"
						color="primary"
						class="m-1"
						@click="resetPassword"
						>Yes</CButton
					>
					<CButton
						type="submit"
						color="secondary"
						class="m-1"
						@click="resetModal = false"
						>No</CButton
					>
				</div>
			</center>
		</CModal>
		<CModal
			title="Response"
			:show.sync="success"
			class="disable-footer"
			centered
			fade
			:closeOnBackdrop="false"
		>
			<center>
				Password changed successfully. You have to login again with the new
				password.
				<div class="inactive-modal-response">
					<CButton
						type="submit"
						color="primary"
						class="m-1"
						@click="handleOnReset"
						>Ok</CButton
					>
				</div>
			</center>
		</CModal>

		<CElementCover v-if="spinner" :opacity="0.8" />
	</CCard>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { storeData } from "../../store";
import queries from "./queries";
import axios from "axios";

export default {
	name: "Login",
	data() {
		return {
			loginDetails: {
				id: storeData.currentUserDetails.id,
				email: storeData.currentUserDetails.email,
				oldPassword: "",
				password: "",
				confirmPassword: "",
			},
			resetModal: false,
			success: false,
			error: null,
			spinner: false,
		};
	},
	mixins: [validationMixin],
	validations: {
		loginDetails: {
			oldPassword: { required, minLength: minLength(8) },
			password: {
				required,
				minLength: minLength(8),
			},
			confirmPassword: {
				required,
				minLength: minLength(8),
				isValid() {
					return (
						this.loginDetails.password === this.loginDetails.confirmPassword
					);
				},
			},
		},
	},
	methods: {
		checkIfValid(fieldName) {
			const field = this.$v.loginDetails[fieldName];
			if (!field.$dirty) {
				return null;
			}
			return !(field.$invalid || field.$model === "");
		},
		validate() {
			this.$v.$touch();
		},

		handleReset() {
			this.validate();
			if (this.$v.$invalid) {
				return;
			}
			this.resetModal = true;
		},

		reset() {
			this.$v.$reset();
			this.loginDetails = {
				id: storeData.currentUserDetails.id,
				email: storeData.currentUserDetails.email,
				oldPassword: "",
				password: "",
				confirmPassword: "",
			};
		},

		async resetPassword() {
			this.spinner = true;
			this.resetModal = false;
			const { id, email, password, oldPassword } = this.loginDetails;
			const res = await axios.post(process.env.VUE_APP_STORE_PASSWORD, {
				id,
				email,
				password,
				oldPassword,
			});

			const result = JSON.parse(res.data.body);
			if (result.statusCode === 200) {
				this.spinner = false;
				this.success = true;
			} else {
				this.spinner = false;
				this.reset();
				this.error = result.message;
			}
		},
		handleOnReset() {
			this.success = false;
			sessionStorage.clear();
			this.$router.push("/login");
		},
	},
};
</script>
